<template>
  <div class="af12-modal">
    <div class="flex h-full bg-white rounded-lg border border-line" style="min-width: 1300px">
      <section class="relative w-20 border-r border-line md:w-48" style="min-width: 12rem">
        <ul class="w-full text-c-desc">
          <li class="af12-left-menu" :class="{active: 0 === tabIdx}" @click.stop="onTab(0)">
            <i class="fi fi-rr-home text-c-default"></i
            ><span class="hidden ml-2 md:inline-block">기본 설정</span>
          </li>
          <li class="af12-left-menu" :class="{active: 1 === tabIdx}" @click.stop="onTab(1)">
            <i class="fi fi-rr-users text-c-default"></i
            ><span class="hidden ml-2 md:inline-block">협력사 설정</span>
          </li>
        </ul>
      </section>
      <div class="relative af12-content">
        <div class="px-5 pt-5">
          <div class="flex justify-between">
            <div class="text-2xl font-semibold">{{ modalTitle }}</div>
            <button class="cs-icon-btn1" @click="onModalClose">
              <i class="fi fi-br-cross text-c-default"></i>
            </button>
          </div>
          <div class="mt-5 border-b border-line"></div>
        </div>
        <setting-default v-if="0 === tabIdx"></setting-default>
        <setting-processes v-if="1 === tabIdx"></setting-processes>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, computed} from "vue";
import SettingDefault from "./modal-setting-default.vue";
import SettingProcesses from "./modal-setting-processes.vue";

const emit = defineEmits(["onModalClose"]);

const tabIdx = ref(0);

const modalTitle = computed(() => {
  if (0 === tabIdx.value) {
    return "기본 설정";
  } else if (1 === tabIdx.value) {
    return "협력사 설정";
  }
  return "기본 설정";
});

const onTab = (idx) => {
  tabIdx.value = idx;
};

const onModalClose = () => {
  emit("onModalClose");
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.af12 {
  &-modal {
    @apply p-5 md:p-10;

    overflow: auto;

    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100vh;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }

  &-close {
    display: flex;
    position: absolute;
    bottom: 1.5rem;
    right: 2.5rem;
  }

  &-left-menu {
    @apply flex items-center justify-center px-6 py-5 border-b border-line cursor-pointer md:justify-start;

    &:hover {
      background-color: var(--theme-bg-hover);
    }

    &.active {
      background-color: var(--theme-bg-hover);
    }
  }

  &-left-close {
    @apply flex items-center justify-center px-6 py-5 border-t border-line cursor-pointer;

    position: absolute;
    bottom: 0px;
    width: 100%;
    text-align: center;
  }

  &-content {
    width: calc(100% - 12rem);
  }
}
</style>
